import api from 'base/utils/api';
import type { GetServerSidePropsContext } from 'next';
import { IGetListParams, IGetSuperFlashsaleParams, IListPage } from 'mod/product-list/interface';
import { getListFeatureConfig } from 'base/servicesV2/feature';
import { getSearch } from 'ava-util/dist/request';
import { getFeatureConfigTheme } from 'mod/theme/service'
import { getCurrentTheme } from 'mod/theme/utils'
import { formatError } from 'base/utils/data';
import { ISFSProduct } from 'mod/feature/interface';

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';

/**
* 获取分页商品列表
 */
export function getListPage({ mock, ...data }: IGetListParams & { mock?: string }): Promise<IListPage> {
    return api.post(mock ? '/api/v2/list' : '/web/v2/list', { data });
}

/**
 * 获取superFlashSale的接口
 * @param data
 */
export function getSuperFlashsaleList(data?: IGetSuperFlashsaleParams): Promise<{ list: ISFSProduct[] }> {
    return api.post('/web/v2/list/superflashsale', { data });
}

export async function getServerSideProps({ params = {}, query, req, resolvedUrl }: GetServerSidePropsContext) {
    const serverPageParams: IGetListParams = {
        pageSize: isPhone ? 8 : 60,
        order: (query.order as string) || 'recommend',
        page: query.p ? Number(query.p as string) : 1,
    };

    const path = params.path as string;

    if (path) {
        if (/-c(\d+)/.test(path)) {
            serverPageParams.listSn = path.replace(/.*-c(\d+).*/, '$1');
        } else if (/-a(\d+)/.test(path)) {
            serverPageParams.catId = path.replace(/.*-a(\d+).*/, '$1');
        } else if (/\d+/.test(path)) {
            serverPageParams.listSn = path;
        }
    } else {
        let q = (query.q as string || '').trim();
        if (!q) {
            q = getSearch(req.url || '').replace(/^(.*)(\?|&)q=(.*)/, '$3').replace(/&|#.*$/, '');
        }
        serverPageParams.searchWords = q;
        if (!q) {
            return {
                props: {
                    error: {
                        message: 'Please input what you want to search'
                    }
                }
            }
        }
    }

    // 置顶商品
    if (query.topp) {
        serverPageParams.topProductIdList = (query.topp as string).split(',')
    }
    // 置顶变体
    if (query.topv) {
        serverPageParams.topVariantIdList = (query.topv as string)?.split(',')
    }

    try {
        const [serverPageData, featureData, theme] = await Promise.all(
            [
                getListPage({
                    ...serverPageParams,
                    getFilter: true,     // 服务端拿一次filter选项
                    mock: query.mock as string
                }),
                getListFeatureConfig({
                    name: isPhone ? 'ListPageH5' : 'ListPagePc',
                    listSn: serverPageParams?.listSn || '0',
                }),
                getFeatureConfigTheme().catch(() => void 0)
            ]
        )
        const currentTheme = getCurrentTheme(theme)

        return {
            props: {
                ageLimit: serverPageData?.ageLimit,
                serverPageParams,
                serverPageData,
                featureData,
                theme: currentTheme || {}
            }
        };
    } catch (e) {
        return { props: { error: formatError(e) } }
    }
}